import React from 'react';
import ReactDOM from 'react-dom';
import VideoCollectionsService from '../VideoCollectionsService';
import VideoCollection from './VideoCollection';
import VideoShowCollection from './VideoShowCollection';
import { getPostId } from '../../shared/utils';

class VideoCollections extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			collections: []
		};
	}

	componentDidMount() {
		const postId = getPostId();
		
		VideoCollectionsService.getCollections(postId).then(collections => {
			this.setState(() => ({
				collections: collections
			}));
			//render nav after collecitons are rendered
			let colNav = document.querySelector('.anchor-nav-wrapper');
			if( colNav ){
				colNav.style.visibility = 'visible';
			}
		})
	}

	componentDidUpdate() {
	}

	render() {
		const collections = this.state.collections;
		let key = 1;

		return (
			<div className={'anchor-container'}>
				{collections.length
					?
					collections.map((c, index)  => {
						let idx = ( 1 + index++ );
						let collectionId = 'collection-' + idx;
						if (c.isShow) {
							return <VideoShowCollection collection={c} key={key++} id={ collectionId } index={ idx }/>
						}
					   else {
						   return <VideoCollection collection={c} key={key++} id={ collectionId } index={ idx } />
					   }
					})
					:
					<div></div>
				}
			</div>
		);
	}
}

let mountNodes = document.getElementsByTagName('VideoCollections');
if (mountNodes.length > 0) {
	ReactDOM.render(<VideoCollections />, mountNodes[0]);
}



// WEBPACK FOOTER //
// ./react-app-src/videoCollections/components/VideoCollections.js